import React from "react";

// Reusable component for rendering individual changelog items
const ChangelogItem = ({ changelog, formatDate, isFirst }) => (
  <div className="changelog-item" style={{ color: 'black' }}>
    <div className="changelog-header">
      <h5 className="changelog-title" style={{ color: 'black' }}>
        {changelog.title}
        {!isFirst && changelog.release_date && <span className="changelog-date" style={{ color: 'black' }}> - {formatDate(changelog.release_date)}</span>}
      </h5>
    </div>
    <div 
      className="changelog-content"
      style={{ color: 'black' }}
      dangerouslySetInnerHTML={{ __html: changelog.content }}
    />
  </div>
);

const ReleaseNotesContent = ({ releaseNotesData }) => {
  // Early return for loading state
  if (!releaseNotesData || !releaseNotesData.changelogs || releaseNotesData.changelogs.length === 0) {
    return (
      <div className="release-notes-text">
        <p>Loading release notes...</p>
      </div>
    );
  }

  // Utility function for date formatting
  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Determine which changelogs to display
  const getChangelogsToDisplay = () => {
    // Always show all changelogs
    return releaseNotesData.changelogs;
  };

  const changelogsToDisplay = getChangelogsToDisplay();

  // Render the changelogs using the reusable component
  return (
    <div className="release-notes-text" style={{ color: 'black' }}>
      {changelogsToDisplay.map((changelog, index) => (
        <React.Fragment key={changelog.id || index}>
          {index === 1 && <h3 style={{ marginTop: '30px', marginBottom: '20px', color: 'black', fontWeight: 'bold' }}>Recent Release Recap</h3>}
          <ChangelogItem 
            changelog={changelog} 
            formatDate={formatDate}
            isFirst={index === 0}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default ReleaseNotesContent; 